module.exports = __webpack_public_path__ + "img/energySaving-icon_3.dd8f2588.png";